// Author : NANDHAKUMAR
// Version :0.0.1
// MODIFIED DATE: 14/11/2025

import { makeApiCall } from '../../../_common/api.utils';
import { API_URL } from '../../../const';

/** ***************** GET ALL COLLECTION DETAILS START *********************** */
export const fixedDepositDetailsGet = (listData: any) => {
	const data = {
		GetMemberFixedDepositToken: listData,
	};
	const url = `${API_URL}getFixedDepositDetails`;
	return makeApiCall(url, data);
};
/** ***************** GET FIXED DEPOSIT DETAILS END *********************** */

/** ***************** ADD FIXED DEPOSIT DETAILS START *********************** */
export const fixedDepositDetailsAdd = (listData: any) => {
	const data = {
		CreateFixedDepositDetailToken: listData,
	};
	const url = `${API_URL}createNewFixedDeposit`;
	return makeApiCall(url, data);
};
/** ***************** ADD FIXED DEPOSIT DETAILS END *********************** */

/** ***************** DELETE FIXED DEPOSIT DETAILS START *********************** */
export const fixedDepositDetailsDelete = (listData: any) => {
	const data = {
		FixedDepositEODDeleteToken: listData,
	};
	const url = `${API_URL}fixedDepositCollectionDelete`;
	return makeApiCall(url, data);
};
/** ***************** DELETE FIXED DEPOSIT DETAILS END *********************** */

/** ***************** FETCH FIXED DEPOSIT COLLCTION APPROVE DETAILS START *********************** */
export const fixedDepositCollectionApproveDetailsGet = (listData: any) => {
	const data = {
		FixedDepositCollectionApproveToken: listData,
	};
	const url = `${API_URL}fixedDepositCollectionApprove`;
	return makeApiCall(url, data);
};
/** ***************** FETCH FIXED DEPOSIT COLLCTION APPROVE DETAILS END *********************** */

/** ***************** FETCH FIXED DEPOSIT COLLCTION APPROVE EOD DETAILS START *********************** */
export const fixedDepositCollectionApproveEodDetailsGet = (listData: any) => {
	const data = {
		FixedDepositCollectionApproveEODToken: listData,
	};
	const url = `${API_URL}approveEODForFixedDeposit`;
	return makeApiCall(url, data);
};
/** ***************** FETCH FIXED DEPOSIT COLLCTION APPROVE EOD DETAILS END *********************** */
